// White circular border rendered behind the bordered sentiment symbols
// (Figma `Border=True`). Shared by all five per-state icons so the border is
// defined in a single place.
export const SENTIMENT_BORDER = (
  <rect
    x={1}
    y={1}
    width={18}
    height={18}
    rx={9}
    fill="var(--hsds-token-color-basics-white, #ffffff)"
    stroke="var(--hsds-token-color-basics-white, #ffffff)"
    strokeWidth={2}
  />
)
